export default "__VITE_ASSET__VW9uh0rF__"